import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService {
  constructor(private http: HttpClient) {}
  baseUrl = environment.baseUrl;

  orderByInv(invoiceno: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/order/getorderbyinv`, { invoiceno });
  }

  generatePDF(payload: any): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/pdf/generatepdf`, payload, {
      responseType: 'blob',
    });
  }

  getCurrentMonthLottery(): Observable<any> {
    return this.http.post(`${this.baseUrl}/lottery/getcurrentmonthlottery`, {});
  }
}
